'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../style/universal.color.js');
const skeleton_types = require('./skeleton.types.js');

var transparent = universal_color.transparent;

var getRadius = function getRadius(_ref) {
  var isCircle = _ref.isCircle,
      borderRadius = _ref.borderRadius;
  return isCircle ? '50%' : "".concat(borderRadius, "px");
};

var getBackgroundColor = function getBackgroundColor(theme, animation) {
  var type = theme && theme.dark ? 'dark' : 'primary';
  var bg = skeleton_types.SkeletonColors[type].main;
  var bgHl = skeleton_types.SkeletonColors[type].highlight;
  return animation ? styled.css(["linear-gradient(90deg,", ",", ",", ");background-color:", ""], bg, bgHl, bg, bg) : styled.css(["", ";background-color:", ""], transparent, bg);
};

var isLoadingOff = function isLoadingOff(isLoading) {
  return typeof isLoading !== 'undefined' && isLoading == false;
};

var getPx = function getPx(val) {
  return val ? typeof val === 'string' ? val : "".concat(val, "px") : 'auto';
};

var StyledBaseSkeleton = styled__default.div.withConfig({
  displayName: "skeletonstyle__StyledBaseSkeleton",
  componentId: "sc-19eg5g3-0"
})(["height:", ";width:", ";background:", ";background-size:", ";border-radius:", ";margin-bottom:", ";background-repeat:no-repeat;&:last-child{margin-bottom:", ";}&.is-loading{> span{display:none;}}animation:", ";@keyframes pulse{0%{background-position:-200px 0;}100%{background-position:calc(200px + 100%) 0;}}"], function (_ref2) {
  var height = _ref2.height;
  return getPx(height);
}, function (_ref3) {
  var width = _ref3.width;
  return getPx(width);
}, function (_ref4) {
  var isLoading = _ref4.isLoading,
      _ref4$theme = _ref4.theme,
      theme = _ref4$theme === void 0 ? {} : _ref4$theme,
      animation = _ref4.animation;
  return typeof isLoading === 'undefined' || isLoading ? getBackgroundColor(theme, animation) : transparent;
}, function (_ref5) {
  var isLoading = _ref5.isLoading;
  return isLoadingOff(isLoading) ? 'auto auto' : '200px 100%';
}, function (props) {
  return getRadius(props);
}, function (_ref6) {
  var margin = _ref6.margin;
  return getPx(margin);
}, function (_ref7) {
  var margin = _ref7.margin;
  return margin ? getPx(margin) : 0;
}, function (_ref8) {
  var animation = _ref8.animation,
      isLoading = _ref8.isLoading;
  return isLoadingOff(isLoading) || !animation ? 'none' : 'pulse 1.2s infinite ease-in-out';
});

exports.StyledBaseSkeleton = StyledBaseSkeleton;
